module.exports = __webpack_public_path__ + "static/light-green-wave-b7d3a728df63d8928374854f723696f3.png";